// @flow

import React from 'react';
import type { Node } from 'react';
import { GridSquare, GridSquareItem } from '@riseart/grid';
import { Section, SectionContent, Wrapper } from '@riseart/layout';
import { CardSimple } from '@riseart/card';
import { PicturePlaceholder } from 'shared_components/common/artdirection/picture/Picture';

type Props = {
  sections: Array<Object>,
  gridOptions?: Object,
};

/**
 * CmsModuleCollections
 */
export const CmsModuleCollections = ({ sections, gridOptions }: Props): Node =>
  sections
    ? sections.map((section, index) => (
        <Section key={index}>
          <Wrapper>
            <SectionContent
              title={section.title}
              headingProps={{ tag: 'h2', level: 3, align: 'center', uppercase: true }}
            >
              <GridSquare columnCount="3" displayStyle="2" {...(gridOptions || null)}>
                {section.items &&
                  section.items.map((item) => (
                    <GridSquareItem columnCount="3" displayStyle="2" key={item.href}>
                      <CardSimple
                        {...(item.type ? { type: item.type } : null)}
                        title={item.title}
                        link={{ external: true, href: item.href }}
                      >
                        <PicturePlaceholder
                          type="grid.cmsEditorialThreeCol"
                          artDirectionKey="cms.collection"
                          image={item.image}
                          alt={item.title}
                          lazyload
                        />
                      </CardSimple>
                    </GridSquareItem>
                  ))}
              </GridSquare>
            </SectionContent>
          </Wrapper>
        </Section>
      ))
    : null;
